export default function generateRandomKey(): string {
    return `field_${Math.random() * 1e7}`.replace(/\./g, '_');
}
